var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"color":"#999","width":"100%","position":"fixed","bottom":"0","padding":"12px 24px","font-size":"12px","text-align":"center"}},[_vm._v(" 宋志海玉雕工作室 ")]),_c('a-modal',{attrs:{"title":"声明","centered":"","okText":"确定","cancelText":"取消"},on:{"ok":function () {
        this$1.show = false;
      }},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',[_vm._v(" 艺瑾杯由苏州工业园区萃玉工艺美术中心举办、苏州工业园区萃玉工艺美术中心内部评奖，主办方享有最终解释权。 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }